import { createApiV2 } from "./common";

export const getGlobalTemplates = () => (token) =>
  createApiV2("GET", "pdf/global_templates/")(token);

export const getGlobalTemplate = (uid) => (token) =>
  createApiV2("GET", `pdf/global_templates/${uid}/`, { preventOutputTransform: true })(token);

export const getCompanyTemplates = () => (token) =>
  createApiV2("GET", "pdf/company_templates/")(token);

export const getCompanyTemplate = (uid) => (token) =>
  createApiV2("GET", `pdf/company_templates/${uid}/`, { preventOutputTransform: true })(token);

export const postCompanyTemplate = (data) => (token) =>
  createApiV2("POST", "pdf/company_templates/", {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })(token, data);

export const patchCompanyTemplate =
  ({ uid, data }) =>
  (token) =>
    createApiV2("PATCH", `pdf/company_templates/${uid}/`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })(token, data);
